import * as React from "react"

import { cn } from "./cn"

/**
 * A card with a heading: the frame of one area of a module page — a form, a
 * table, a report. In the AVEX design it is the design system's Card; in the
 * classic look the white rounded panel the modules drew by hand before.
 */
function Section({
  title,
  description,
  actions,
  className,
  children,
  ...props
}: Omit<React.ComponentProps<"section">, "title"> & {
  title?: React.ReactNode
  description?: React.ReactNode
  /** Controls at the right of the heading, such as a filter or a button. */
  actions?: React.ReactNode
}) {
  const head = title !== undefined || actions !== undefined
  return (
    <section
      data-slot="section"
      className={cn(
        "flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm",
        "avex:rounded-avex-lg avex:border-0 avex:bg-surface avex:p-5 avex:shadow-avex-sm",
        className
      )}
      {...props}
    >
      {head && (
        <header className="flex flex-wrap items-start justify-between gap-3">
          <div className="flex min-w-0 flex-col gap-1">
            {title !== undefined && (
              <h2 className="text-base font-semibold text-gray-900 avex:text-[0.9375rem] avex:text-ink">{title}</h2>
            )}
            {description !== undefined && (
              <p className="text-sm text-gray-500 avex:text-ink-secondary">{description}</p>
            )}
          </div>
          {actions !== undefined && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  )
}

export { Section }
